import {
  Panel,
  PanelSection,
  EmptyState,
  EmptyStateTitle,
  EmptyStateDescription,
  Text,
} from '@customerio/pluma-components/react';

interface VerificationStatusEscalatedProps {
  userEmail: string | null | undefined;
}

export function VerificationStatusEscalated({ userEmail }: VerificationStatusEscalatedProps) {
  return (
    <Panel>
      <PanelSection display="flex" justifyContent="center" alignItems="center" p="400">
        <EmptyState>
          <EmptyStateTitle icon="view-on">Verification under review</EmptyStateTitle>
          <EmptyStateDescription>
            Your account verification request has been escalated for manual review. Our team will contact you at{' '}
            {userEmail != null ? (
              <Text as="span" weight="semibold">
                {userEmail}
              </Text>
            ) : (
              'your email'
            )}{' '}
            with updates in 24 - 48 hours.
          </EmptyStateDescription>
        </EmptyState>
      </PanelSection>
    </Panel>
  );
}
